module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"レビューの作成が完了しました。","subtitle":"貴重なご意見をいただきありがとうございます。","reward":"{0} 付与予定","my_reviews_button":"自分のレビューを見る"}}')
  delete Component.options._Ctor
}
